// Broker password requirements — the ONE place these rules live in the SPA.
//
// This mirrors the broker Cognito User Pool's password policy (pool
// `pms-sandbox-brokers`): minimum length 12, plus an uppercase, lowercase,
// number, and symbol. PMS/Cognito remains the authoritative validator (a
// non-conforming password still comes back as a 400 "Password does not meet
// the requirements."); this is purely to TELL the broker the rules up front so
// they aren't guessing. If the pool policy changes, update it here.

export interface PasswordRule {
  /** Stable id for keys/tests. */
  id: string;
  /** Human-readable requirement shown to the broker. */
  label: string;
  /** True when the candidate password satisfies this rule. */
  test: (password: string) => boolean;
}

export const PASSWORD_MIN_LENGTH = 12;

export const passwordRules: PasswordRule[] = [
  {
    id: "length",
    label: `At least ${PASSWORD_MIN_LENGTH} characters`,
    test: (p) => p.length >= PASSWORD_MIN_LENGTH,
  },
  {
    id: "uppercase",
    label: "An uppercase letter",
    test: (p) => /[A-Z]/.test(p),
  },
  {
    id: "lowercase",
    label: "A lowercase letter",
    test: (p) => /[a-z]/.test(p),
  },
  { id: "number", label: "A number", test: (p) => /[0-9]/.test(p) },
  {
    id: "symbol",
    label: "A symbol (e.g. ! @ # $ %)",
    // Anything that isn't a letter, number, or whitespace counts as a symbol.
    test: (p) => /[^A-Za-z0-9\s]/.test(p),
  },
];

/** The rules a password does NOT yet satisfy (empty = meets the policy). */
export function unmetPasswordRules(password: string): PasswordRule[] {
  return passwordRules.filter((rule) => !rule.test(password));
}
